import { ICasino } from 'constants/types';

export const getCasinoRTP = (casino: ICasino) => {
  return {
    string: (casino?.RTP ?? 0)?.toFixed(2) + '%',
    number: casino?.RTP ?? 0,
  };
};
